import { currentBrand } from './brand'

// 以下是当前品牌的个性化配置数据。品牌差异统一维护在 brand.js。
const CONFIG = {
  appId: currentBrand.appId,
  env: currentBrand.env,
  // 注意,这里虽然对应服务端test和prod环境文件中并没有api路径,但仍需要增加此路径,是因为 nginx 对它进行了处理.
  servePath: currentBrand.servePath // 接口的基础配置信息, 如 /wnysmart/api 或 /api
}

export default CONFIG;
